module.exports = __webpack_public_path__ + "static/iceDragon-ce51201b7a62fcaec3c8fe30c5ea6154.jpg";